import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import MachineCreateWizard from "pages/vending/machine/create/MachineCreateWizard";
import MachineList from "pages/vending/machine/list/MachineList";
import React from "react";
import { GiVendingMachine } from "react-icons/gi";
import { ImMagicWand } from "react-icons/im";
import { useSelector } from "react-redux";

const Machine = () => {
  const roles = useSelector((state) => state.auth.user.roles);
  return (
    <>
      {roles.any(["super_admin"]) ? (
        <Box sx={{ display: "flex", flex: 1 }}>
          <ListCreateTab
            mod="Machine"
            viewIcon={<GiVendingMachine />}
            createIcon={<ImMagicWand />}
            createChildren={<MachineCreateWizard />}
            listChildren={<MachineList />}
          />
        </Box>
      ) : (
        <Box padding={3}>
          <MachineList />
        </Box>
      )}
    </>
  );
};

export default Machine;
